import React from 'react';
import { Button, Typography } from '@mui/material';

type Props = {
  onClick: () => void;
};

/**
 * Standalone "Undo" link used by suggestion previews to back out an
 * accepted or dismissed suggestion before it's been committed.
 */
const SuggestionUndoButton = ({ onClick }: Props) => (
  <Button
    variant="text"
    size="small"
    onClick={onClick}
    sx={{
      p: 0,
      minWidth: 0,
      alignSelf: 'flex-start',
    }}
  >
    <Typography variant="captionBold" color="primary.main">Undo</Typography>
  </Button>
);

export default SuggestionUndoButton;
